import { useState, useEffect } from "react";
import { authorizedPost } from "../../scripts/functions/AuthService";

import {MenuItem} from "@mui/material";
import { Button } from "@mui/material";
import Text from "../../components/Text";
import Logo from "../../components/Logo";
import Dropdown from "../../components/Dropdown";
import { Col, Row } from "../../components/Flexbox";
import TextContainer from "../../components/TextContainer";
import HappyPapelin from "../../components/icons/HappyPapelin";
import { useTheme } from "../../scripts/functions/ThemeProvider";

const Quejas = () => {
    const {theme, isDark} = useTheme();
    const [nombre, setNombre] = useState("");
    const [area, setArea] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const areas = ["Flexografía", "Offset", "Calidad", "Ventas", "IT", "Sistemas", 
        "Planeación", "Recursos Humanos", "Contabilidad", "Finanzas", "Compras", 
        "Mantenimiento", "Preprensa", "Administración", "Almacén"]

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = windowWidth < 720;

    const isValid = nombre.trim() !== "" && area.trim() !== "" && mensaje.trim() !== "" && !isSubmitting;

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!isValid) return;
        
        setIsSubmitting(true);
        try {
            const payload = {
                name: nombre,
                message: mensaje,
                area: area
            };

            const response = await authorizedPost("/suggestions/sender", payload);
            const resData = await response.body.json();

            setNombre("")
            setArea("")
            setMensaje("")

            return {success: true, data: resData}
        } catch(e) {
            console.error("Error al mandar la sugerencia: ", e);
            const errData = await new Response(e.response.body).json();
            const message = errData.message;
            return {success: false, message: message};
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <Col style={{minHeight: '100vh', width: '100%', justifyContent: 'flex-start', alignItems: 'center', gap: 48, paddingTop: 36, paddingBottom: 36, boxSizing: 'border-box', backgroundColor: theme.Alfalfa}}>
                <Row style={{flex: 'none'}}>
                    <Logo height={128} width={128}/>
                </Row>
                <Row style={{backgroundColor: theme.White, padding: '32px 38px', borderRadius: 8, border: `1px solid ${theme.Ey}`, maxWidth: 976, width: 'calc(100% - 32px)', gap: isMobile ? 48 : 200, flexWrap: 'wrap', flex: 'none', alignItems: 'flex-start', boxSizing: 'border-box'}}>
                    <Col style={{width: '100%', minWidth: 0, flex: '1 1 220px', gap: 32, justifyContent: 'flex-start', alignItems: 'center'}}>
                        <Text size={22} color={theme.Black} weight="bold" style={{textAlign: 'center'}}>
                            ¡Queremos escucharte!
                        </Text>
                        <HappyPapelin width="140" height="224"/>
                        <Text size={16} style={{textAlign: 'center'}} color={theme.Black}>
                            Comparte tus inquietudes, ideas y/o sugerencias de mejora y daremos seguimiento puntual.
                        </Text>
                    </Col>
                        <Col style={{gap: 18, width: '100%', minWidth: 0, flex: '1 1 240px', alignItems: 'stretch', justifyContent: 'flex-start'}}>
                            <Col style={{gap: 4, alignItems: 'stretch', width: '100%'}}>
                                <Text color={theme.Black} style={{textAlign: 'start'}}>Nombre completo o número de nómina</Text>
                                <TextContainer theme={theme} style={{width: '100%', height: 36}} placeHolder='Nombre Completo' value={nombre} onChange={setNombre}/>
                            </Col>
                            <Col style={{gap: 4, alignItems: 'stretch', width: '100%'}}>
                                <Text color={theme.Black} style={{textAlign: 'start'}}>Departamento</Text>
                                <Dropdown theme={theme} placeholder="Departamento" value={area} onChange={setArea} style={{width: '100%', height: 36}}>
                                    {areas.sort().map((area) => (
                                        <MenuItem value = {area}>{area}</MenuItem>
                                    ))}
                                </Dropdown>
                            </Col>
                            <Col style={{gap: 4, alignItems: 'stretch', width: '100%'}}>
                                <Text color={theme.Black} style={{textAlign: 'start'}}>Mensaje</Text>
                                <TextContainer theme={theme} style={{width: '100%', height: 96}} multiline placeHolder='Escribe aquí tu mensaje' value={mensaje} onChange={setMensaje}/>
                            </Col>
                            <div style={{width: '100%'}}>
                                <Button type="submit" disabled={!isValid} variant="contained" sx={{width: '100%', height: 52, border: 1, borderColor: theme.Coco, backgroundColor: isValid ? theme.Black : theme.Ey, color: isValid ? theme.White : theme.Audi, fontWeight: 'medium', fontSize: 15, textTransform: 'none', '&.Mui-disabled': {backgroundColor: isDark ? theme.Audi : theme.Ey}, marginTop: 3}}>
                                    {isSubmitting ? "Enviando..." : "Enviar"}
                                </Button>            
                            </div>
                        </Col>
                </Row>
            </Col>
        </form>
    )
}

export default Quejas;